import React from "react";
import instagram from "../../assets/images/instagram.png";
import tiktok from "../../assets/images/tiktok.png";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const DashboardFooter = () => {
    const { t, i18n } = useTranslation();
    const isRTL = i18n.language === 'ar';
  
  return (
    <footer
      className="inter-font text-white px-3 py-2"
      style={{
        background: "#7B6E43",
        direction: isRTL ? "rtl" : "ltr"
      }}
    >
      <div className="inter-font container-fluid">
        <div className="inter-font row align-items-center text-center text-md-start">
          {/* Left: Copyright */}
          <div className="inter-font col-12 col-md-4 mb-2 mb-md-0" style={{ textAlign: isRTL ? "right" : "left" }}>
            <div>{t("copyright")}</div>
          </div>

          {/* Center: Links */}
          <div className="inter-font col-12 col-md-4 mb-2 mb-md-0" style={{ textAlign: "center" }}>
            <div>
              <Link to="/privacy-policy" className="text-white mx-2">{t("privacy_policy")}</Link>
              <span className="mx-2">|</span>
              <Link to="/terms-and-conditions" className="text-white mx-2">{t("terms_condition")}</Link>
            </div>
          </div>

          {/* Right: Social Icons */}
          <div className="inter-font col-12 col-md-4">
            <div 
              className="inter-font social-icons-dashboard d-flex justify-content-center align-items-center justify-content-md-end flex-wrap"
              style={{ 
                justifyContent: isRTL ? "flex-start" : "flex-end"
              }}
            >
              <a
                href="https://www.instagram.com/nahhamuae?igsh=cjdvNjljbXcza2sw"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={instagram} alt="Instagram" className="inter-font mx-1" />
              </a>
              <a
                href="https://www.tiktok.com/@nahhamuae?_t=ZS-8y6OUT4PWkM&_r=1"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={tiktok} alt="TikTok" className="inter-font mx-1" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default DashboardFooter;